import React from 'react'
import Keyboard from 'react-simple-keyboard'
import 'react-simple-keyboard/build/css/index.css'
import theLayout from 'simple-keyboard-layouts/build/layouts/french'
import Util from './Util'
import HorizontalSlider from './HorizontalSlider'
import VolumeSlider from './VolumeSlider'
import Audio from './Audio.js'
import Timer from './Timer.js'
import Atmospheres from './Atmospheres.js'
import Com from './Com.js'
import Animation from './Animation.js'
import MagicData from './MagicData.js'
import Translations from './Translations.js'

// icons : https://mui.com/material-ui/material-icons/

// Songs

let Songs = null
async function loadSongs() {
	await fetch("../songs/Songs.json")
	.then((response) => response.text())
	.then(function (text) {
		Songs = JSON.parse(text)
	})
}
await loadSongs()

let songsList = []
for (let songId in Songs) {
	let song = Songs[songId]
	songsList.push(songId)
}
//Util.shuffle(songsList)
for (let songId in Songs) {
	let song = Songs[songId]
	song.normalizedStrings = Util.normalizeString(song.title).concat(Util.normalizeString(song.artist))
}

// Constants
let categories = [
	['RÉCENT'],
	['KIDS'],
	['JAZZ', 'BLUES', 'SOUL'],
	['FRANÇAIS'],
	['POP'],
	['LOVE'],
	['DUOS'],
	['ROCK'],
	['DISCO', 'FUNK'],
	['DANCE', 'ELECTRO'],
	['RAP', 'RNB'],
	['FILMS', 'TV'],
	['ANGLAIS'],
	['ESPAGNOL'],
	['MUSIQUES DU MONDE'],
	['ANNÉES 2010'],
	['ANNÉES 2000'],
	['ANNÉES 90'],
	['ANNÉES 80'],
	['ANNÉES 70'],
	['OLDIES']
]

// Variables
let micro1VolumeMagicData = MagicData.newMagicData(0.25)
let micro2VolumeMagicData = MagicData.newMagicData(0.25)
let softVolumeMagicData = MagicData.newMagicData(0.25)
let systemMicrosVolumeMagicData = MagicData.newMagicData(0.5)
let systemSoftVolumeMagicData = MagicData.newMagicData(0.25)
let guideMagicData = MagicData.newMagicData(false)
let autoTuneMagicData = MagicData.newMagicData(false)
let musicTimerConfMagicData = MagicData.newMagicData(null)
let musicTimerPositionMagicData = MagicData.newMagicData(null)
let sessionAmountMagicData = MagicData.newMagicData(0)
let sessionTimerConfMagicData = MagicData.newMagicData(null)
let sessionTimerPositionMagicData = MagicData.newMagicData(null)
let assistanceTimerConfMagicData = MagicData.newMagicData(null)
let assistanceTypeMagicData = MagicData.newMagicData(null)
let dialogMagicData = MagicData.newMagicData(null)
let keyboardVisibleMagicData = MagicData.newMagicData(false)
let numPadVisibleMagicData = MagicData.newMagicData(false)
let searchTermMagicData = MagicData.newMagicData('')
let numPadValueMagicData = MagicData.newMagicData('')
let currentCategoryMagicData = MagicData.newMagicData(null)
let playlistMagicData = MagicData.newMagicData([])
let playerIndexMagicData = MagicData.newMagicData(0)
let loadingMagicData = MagicData.newMagicData(false)
let atmosphereIdMagicData = MagicData.newMagicData('welcome')
let scrollAtmospheres = 0
let resetTilesScroll = false
let resetPlaylistScroll = false
let categoriesTilesScrollValue = 0
let atmosphereIdsHistory = []
let barCallsMagicData = MagicData.newMagicData(false)
let assistanceCallsMagicData = MagicData.newMagicData(false)
let photosensibleModeMagicData = MagicData.newMagicData(false)
let accessibilityModeMagicData = MagicData.newMagicData(false)
let secretCodeMagicData = MagicData.newMagicData(null)
let demoMagicData = MagicData.newMagicData(false)
let tmpMagicData = MagicData.newMagicData(10)
let localeMagicData = MagicData.newMagicData('fr')
let activeGameMagicData = MagicData.newMagicData(null)
let softMagicData = MagicData.newMagicData(null)

photosensibleModeMagicData.addChangeCb(function(newValue) {
	if (newValue) Com.setVariable('', 'atmosphereId', 'neutral')
})

let modeDemoIntervalId = null
demoMagicData.addChangeCb(function(newValue) {
	if (newValue) {
		if (modeDemoIntervalId) return
		function tic() {
			let songId = songsList[Math.floor(Math.random()*songsList.length)]
			playSong(songId, 0)
		}
		modeDemoIntervalId = setInterval(tic, 29*1000)
		tic()
	}
	else {
		if (!modeDemoIntervalId) return
		clearInterval(modeDemoIntervalId)
		modeDemoIntervalId = null
	}
})

searchTermMagicData.addChangeCb(function(newValue) {
	resetTilesScroll = true
	if (newValue === 'az shutdown') Com.setVariable('', 'system', 'shutdown')
	else if (newValue === 'az dmx') Com.setVariable('', 'atmosphereId', 'earth2')
	else if (newValue === 'az demo') Com.setVariable('', 'demo', true)
	else if (newValue === 'az lyrics') {
		let playlist = []
		for (let songId in Songs) {
			let song = Songs[songId]
			if (song.singer1 === '?' || song.singer2 === '?' || song.singer3 === '?' || song.singer4 === '?') {
				playlist.push(songId)
			}
		}
		Com.setVariable('', 'playlist', playlist)
	}
})

numPadValueMagicData.addChangeCb(function(newValue) {
	let secretCode = secretCodeMagicData.getValue()
	if (secretCode && newValue.startsWith(secretCode)) {
		let amount = newValue.substring(secretCode.length)
		if (amount != '') {
			amount = parseInt(amount)
			Com.setVariable('', 'sessionAmount', amount*60)
		}
	}
})

softVolumeMagicData.addChangeCb(Audio.setVolume)
systemSoftVolumeMagicData.addChangeCb(Audio.setSystemVolume)
guideMagicData.addChangeCb(Audio.setGuide)

function playSong(songId, songIdx) {
	let song = Songs[songId]
	loadingMagicData.setValue(true)
	Com.setVariable('', 'musicTimerConf', null)
	// Change player index
	Com.setVariable('', 'playerIndex', songIdx)
	Audio.load(songId, function() {
		Com.setVariable('', 'musicTimerConf', [Date.now(), 0, song.duration, 0.02, songId])
		loadingMagicData.setValue(false)
		// Change atmosphere
		if (!photosensibleModeMagicData.getValue()) {
			if (song.atmosphereIds && song.atmosphereIds.length > 0) {
				let atmosphereIdCandidates = Array.from(song.atmosphereIds)
				atmosphereIdCandidates.splice(atmosphereIdCandidates.indexOf('neutral'), 1)
				let reverseAtmosphereIdsHistory = Array.from(atmosphereIdsHistory).reverse()
				for (let atmosphereId of reverseAtmosphereIdsHistory) {
					if (atmosphereIdCandidates.length === 1) break
					let foundIndex = atmosphereIdCandidates.indexOf(atmosphereId)
					if (foundIndex > -1) atmosphereIdCandidates.splice(foundIndex, 1)
				}
				if (atmosphereIdCandidates.length > 1) {
					let randomIndex = Math.floor(Math.random()*atmosphereIdCandidates.length)
					atmosphereIdCandidates = [atmosphereIdCandidates[randomIndex]]
				}
				Com.setVariable('', 'atmosphereId', atmosphereIdCandidates[0])
			}
			else Com.setVariable('', 'atmosphereId', 'neutral')
		}
	})
}

musicTimerConfMagicData.addChangeCb(function() {
	if (musicTimerConfMagicData.getValue() === null) return
	let [startDate, startPosition, duration, period, songId] = musicTimerConfMagicData.getValue()
	if (period === 0) Audio.stop()
	else {
		Audio.play(songId, startPosition)
		if (startPosition === 0) {
			scrollAtmospheres = 1
			resetPlaylistScroll = true
		}
	}
})

Timer.newTimer(sessionTimerConfMagicData, sessionTimerPositionMagicData, function() {
	if (
		!musicTimerConfMagicData.getValue()
		|| musicTimerConfMagicData.getValue()[3] === 0
	) {
		Com.setVariable('', 'sessionAmount', 0)
	}
})
Timer.newTimer(musicTimerConfMagicData, musicTimerPositionMagicData, function() {
	if (sessionTimerPositionMagicData.getValue() >= sessionAmountMagicData.getValue()) {
		Com.setVariable('', 'sessionAmount', 0)
		return
	}
	let currentSong = Songs[musicTimerConfMagicData.getValue()[4]]
	let playlist = playlistMagicData.getValue()
	let i = playerIndexMagicData.getValue()
	if (i === playlist.length-1) {
		Com.setVariable('', 'musicTimerConf', [Date.now(), 0, currentSong.duration, 0, currentSong.id])
	}
	else {
		let nextSongIdx = i+1
		let nextSongId = playlist[nextSongIdx]
		playSong(nextSongId, nextSongIdx)
	}
})

let initialized = false
function init() {
	initialized = true

	sessionAmountMagicData.addChangeCb(function(newValue, oldValue) {
		if (!oldValue && !newValue) {
			return
		}
		if (newValue === null) {
			return
		}
		if (
			newValue === 0
			|| (sessionTimerPositionMagicData.getValue() !== null && sessionTimerPositionMagicData.getValue() >= newValue)
		) {
			Com.setVariable('', 'demo', false)
			Com.setVariable('', 'sessionTimerConf', null)
			Com.setVariable('', 'micro1Volume', 0.25)
			Com.setVariable('', 'micro2Volume', 0.25)
			Com.setVariable('', 'settings.volume', 0.25)
			Com.setVariable('', 'guide', false)
			Com.setVariable('', 'autoTune', false)
			Com.setVariable('', 'musicTimerConf', null)
			Com.setVariable('', 'assistanceTimerConf', null)
			Com.setVariable('', 'assistanceType', null)
			Com.setVariable('', 'dialog', null)
			Com.setVariable('', 'keyboardVisible', false)
			Com.setVariable('', 'searchTerm', '')
			Com.setVariable('', 'currentCategory', null)
			Com.setVariable('', 'playlist', [])
			Com.setVariable('', 'playerIndex', 0)
			Com.setVariable('', 'photosensibleMode', false)
			Com.setVariable('', 'accessibilityMode', false)
			loadingMagicData.setValue(false)
			atmosphereIdsHistory = []
			Com.setVariable('', 'atmosphereId', 'welcome')
			Audio.stop()
			Com.setVariable('', 'activeGame', null)
			//Util.shuffle(songsList)
		}
		else if (sessionTimerConfMagicData.getValue()) {
			//Com.setVariable('', 'sessionTimerConf', [Date.now(), sessionTimerPositionMagicData.getValue(), newValue, 1])
			Com.setVariable('', 'sessionTimerConf', [Date.now(), 0, newValue, 1])
		}
	})

	Com.connectMagicData(sessionAmountMagicData, '', 'sessionAmount', true)
	Com.connectMagicData(sessionTimerConfMagicData, '', 'sessionTimerConf')
	Com.connectMagicData(micro1VolumeMagicData, '', 'micro1Volume', true)
	Com.connectMagicData(micro2VolumeMagicData, '', 'micro2Volume', true)
	Com.connectMagicData(musicTimerConfMagicData, '', 'musicTimerConf')
	Com.connectMagicData(assistanceTimerConfMagicData, '', 'assistanceTimerConf')
	Com.connectMagicData(assistanceTypeMagicData, '', 'assistanceType')
	Com.connectMagicData(dialogMagicData, '', 'dialog')
	Com.connectMagicData(keyboardVisibleMagicData, '', 'keyboardVisible')
	Com.connectMagicData(numPadVisibleMagicData, '', 'numPadVisible')
	Com.connectMagicData(searchTermMagicData, '', 'searchTerm')
	Com.connectMagicData(numPadValueMagicData, '', 'numPadValue')
	Com.connectMagicData(currentCategoryMagicData, '', 'currentCategory')
	Com.connectMagicData(playlistMagicData, '', 'playlist')
	Com.connectMagicData(playerIndexMagicData, '', 'playerIndex')
	Com.connectMagicData(autoTuneMagicData, '', 'autoTune', true)
	Com.connectMagicData(guideMagicData, '', 'guide')
	Com.connectMagicData(softVolumeMagicData, '', 'settings.volume')
	Com.connectMagicData(systemSoftVolumeMagicData, '', 'systemSoftVolume', true)
	Com.connectMagicData(systemMicrosVolumeMagicData, '', 'systemMicrosVolume', true)
	Com.connectMagicData(atmosphereIdMagicData, '', 'atmosphereId', true)
	Com.connectMagicData(barCallsMagicData, '', 'barCalls', false)
	Com.connectMagicData(assistanceCallsMagicData, '', 'assistanceCalls', false)
	Com.connectMagicData(photosensibleModeMagicData, '', 'photosensibleMode')
	Com.connectMagicData(accessibilityModeMagicData, '', 'accessibilityMode')
	Com.connectMagicData(secretCodeMagicData, '', 'secretCode')
	Com.connectMagicData(demoMagicData, '', 'demo')
	Com.connectMagicData(tmpMagicData, '', 'tmp')
	Com.connectMagicData(localeMagicData, '', 'locale')
	Com.connectMagicData(activeGameMagicData, '', 'activeGame')
	Com.connectMagicData(softMagicData, '', 'soft')

	atmosphereIdMagicData.addChangeCb(function(newValue) {
		if (!Atmospheres[newValue]) Com.setVariable('', 'atmosphereId', 'welcome')
		atmosphereIdsHistory.push(newValue)
		if (scrollAtmospheres === 1) {
			scrollAtmospheres = 2
		}
	})

	let windowLocationCb = function(newValue) {
		if (!softMagicData.getValue()) return
		if (softMagicData.getValue() === 'KaraWorld') return
		if (softMagicData.getValue() === 'v2' && !activeGameMagicData.getValue()) window.location.href = 'http://localhost:42520/quiz2/index.html?monitor=kiosk'
	}
	activeGameMagicData.addChangeCb(windowLocationCb)
	softMagicData.addChangeCb(windowLocationCb)

	// Réinit tout au chargement
	Com.setVariable('', 'demo', false)
	Com.setVariable('', 'micro1Volume', 0.25)
	Com.setVariable('', 'micro2Volume', 0.25)
	Com.setVariable('', 'guide', false)
	Com.setVariable('', 'autoTune', false)
	Com.setVariable('', 'musicTimerConf', null)
	Com.setVariable('', 'assistanceTimerConf', null)
	Com.setVariable('', 'assistanceType', null)
	Com.setVariable('', 'dialog', null)
	Com.setVariable('', 'keyboardVisible', false)
	Com.setVariable('', 'searchTerm', '')
	Com.setVariable('', 'currentCategory', null)
	Com.setVariable('', 'playlist', [])
	Com.setVariable('', 'playerIndex', 0)
	Com.setVariable('', 'photosensibleMode', false)
	Com.setVariable('', 'accessibilityMode', false)
	Com.setVariable('', 'atmosphereId', 'welcome')

}

function Terminal() {

	if (!initialized) init()

	const [musicTimerPosition, setMusicTimerPosition] = React.useState(musicTimerPositionMagicData.getValue())
	const [micro1Volume, setMicro1Volume] = React.useState(micro1VolumeMagicData.getValue())
	const [micro2Volume, setMicro2Volume] = React.useState(micro2VolumeMagicData.getValue())
	const [softVolume, setSoftVolume] = React.useState(softVolumeMagicData.getValue())
	const [guide, setGuide] = React.useState(guideMagicData.getValue())
	const [autoTune, setAutoTune] = React.useState(autoTuneMagicData.getValue())
	const [dialog, setDialog] = React.useState(dialogMagicData.getValue())
	const [keyboardVisible, setKeyboardVisible] = React.useState(keyboardVisibleMagicData.getValue())
	const [numPadVisible, setNumPadVisible] = React.useState(numPadVisibleMagicData.getValue())
	const [sessionAmount, setSessionAmount] = React.useState(sessionAmountMagicData.getValue())
	const [sessionTimerPosition, setSessionTimerPosition] = React.useState(sessionTimerPositionMagicData.getValue())
	const [assistanceType, setAssistanceType] = React.useState(assistanceTypeMagicData.getValue())
	const [musicTimerConf, setMusicTimerConf] = React.useState(musicTimerConfMagicData.getValue())
	const [sessionTimerConf, setSessionTimerConf] = React.useState(sessionTimerConfMagicData.getValue())
	const [searchTerm, setSearchTerm] = React.useState(searchTermMagicData.getValue())
	const [numPadValue, setNumPadValue] = React.useState(numPadValueMagicData.getValue())
	const [currentCategory, setCurrentCategory] = React.useState(currentCategoryMagicData.getValue())
	const [playlist, setPlaylist] = React.useState(playlistMagicData.getValue())
	const [playerIndex, setPlayerIndex] = React.useState(playerIndexMagicData.getValue())
	const [animateTile, setAnimateTile] = React.useState(null)
	const [animateTileOffset, setAnimateTileOffset] = React.useState(null)
	const [loading, setLoading] = React.useState(loadingMagicData.getValue())
	const [atmosphereId, setAtmosphereId] = React.useState(atmosphereIdMagicData.getValue())
	const [barCalls, setBarCalls] = React.useState(barCallsMagicData.getValue())
	const [assistanceCalls, setAssistanceCalls] = React.useState(assistanceCallsMagicData.getValue())
	const [photosensibleMode, setphotosensibleMode] = React.useState(photosensibleModeMagicData.getValue())
	const [accessibilityMode, setAccessibilityMode] = React.useState(accessibilityModeMagicData.getValue())
	const [tmp, setTmp] = React.useState(tmpMagicData.getValue())
	const [locale, setLocale] = React.useState(localeMagicData.getValue()) 
	const [soft, setSoft] = React.useState(softMagicData.getValue()) 

	// fonction translations
	function _(aText) {
		if (!Translations[locale]) return aText
		if (!Translations[locale][aText]) return aText
		return Translations[locale][aText]
	}

	const searchInputRef = React.useRef()

	micro1VolumeMagicData.addChangeCb(setMicro1Volume)
	micro2VolumeMagicData.addChangeCb(setMicro2Volume)
	softVolumeMagicData.addChangeCb(setSoftVolume)
	guideMagicData.addChangeCb(setGuide)
	autoTuneMagicData.addChangeCb(setAutoTune)
	musicTimerPositionMagicData.addChangeCb(setMusicTimerPosition)
	sessionAmountMagicData.addChangeCb(setSessionAmount)
	sessionTimerPositionMagicData.addChangeCb(setSessionTimerPosition)
	assistanceTypeMagicData.addChangeCb(setAssistanceType)
	musicTimerConfMagicData.addChangeCb(setMusicTimerConf)
	sessionTimerConfMagicData.addChangeCb(setSessionTimerConf)
	dialogMagicData.addChangeCb(setDialog)
	keyboardVisibleMagicData.addChangeCb(setKeyboardVisible)
	numPadVisibleMagicData.addChangeCb(setNumPadVisible)
	searchTermMagicData.addChangeCb(setSearchTerm)
	numPadValueMagicData.addChangeCb(setNumPadValue)
	currentCategoryMagicData.addChangeCb(setCurrentCategory)
	playlistMagicData.addChangeCb(setPlaylist)
	playerIndexMagicData.addChangeCb(setPlayerIndex)
	loadingMagicData.addChangeCb(setLoading)
	atmosphereIdMagicData.addChangeCb(setAtmosphereId)
	barCallsMagicData.addChangeCb(setBarCalls)
	assistanceCallsMagicData.addChangeCb(setAssistanceCalls)
	photosensibleModeMagicData.addChangeCb(setphotosensibleMode)
	accessibilityModeMagicData.addChangeCb(setAccessibilityMode)
	tmpMagicData.addChangeCb(setTmp)
	localeMagicData.addChangeCb(setLocale) 
	softMagicData.addChangeCb(setSoft) 

	let session = ''
	if (sessionAmount === 0) session = 'closed'
	else if (sessionTimerConf === null) session = 'waitForClick'
	else if (sessionAmount-sessionTimerPosition <= 0) session = 'lastSong'
	else session = 'opened'

	let currentSong = musicTimerConf ? Songs[musicTimerConf[4]] : null
	let playing = musicTimerConf && musicTimerConf[3] !== 0

	// Tiles
	let effectiveSearchTerm = searchTerm.trim()
	if (effectiveSearchTerm.length < 3) effectiveSearchTerm = ''
	let filteredSongs = null
	if (currentCategory !== null) {
		filteredSongs = []
		for (let songId of songsList) {
			let song = Songs[songId]
			if (song.categories.indexOf(currentCategory) !== -1) {
				filteredSongs.push(song)
			}
		}
	}
	else if (effectiveSearchTerm !== '') {
		filteredSongs = []
		for (let songId of songsList) {
			let song = Songs[songId]
			for (let normalizedString of song.normalizedStrings) {
				if (normalizedString.indexOf(effectiveSearchTerm) !== -1) {
					filteredSongs.push(song)
					break
				}
			}
		}
	}
	if (filteredSongs) filteredSongs = filteredSongs.slice(0, 300)
	let tilesHeight = 3
	let tilesWidth = Math.max(Math.ceil((filteredSongs||categories).length/tilesHeight),3)+1

	Animation.animate = function() {
		if (animateTile) {
			if (document.getElementById('animateTile')) {
				if (100+148*animateTile.x+animateTileOffset > 860) setAnimateTile(null)
				else setAnimateTileOffset(animateTileOffset+70)
			}
		}
	}

	React.useEffect(function() {
		if (resetTilesScroll) {
			let element = document.getElementById('tiles')
			if (element) element.scrollLeft = 0
			resetTilesScroll = false
		}
		if (resetPlaylistScroll) {
			let element = document.getElementById('playlist')
			if (element) element.scrollLeft = playerIndex*320
			resetPlaylistScroll = false
		}
		if (scrollAtmospheres === 2) {
			let element = document.getElementById('atmospheres')
			if (element) element.scrollLeft = currentSong.atmosphereIds.indexOf(atmosphereIdMagicData.getValue())*320
			scrollAtmospheres = 0
		}
	})

	return (
		<div className={accessibilityMode?'accessibilityMode':''} style={{width: '1080px', height: '1920px', background: 'black', color: 'white', textAlign: 'center', overflow: 'hidden', position: 'absolute'}} onClick={function(event) {
			let vv = window.visualViewport
			let vw = vv ? vv.width : window.innerWidth
			let vh = vv ? vv.height : window.innerHeight
			let scale = Math.min(vw/1080, vh/1920)
			let x = event.clientX/scale
			let y = event.clientY/scale
			const threshold = 80
			if (x >= 1080 - threshold && y >= 1920 - threshold) {
				Com.setVariable('', 'numPadVisible', !numPadVisible)
				Com.setVariable('', 'numPadValue', '')
			}
		}}>

			{/* Logo client */}
			<div
				style={{position: 'absolute', left: '0px', top: '0px', zIndex: '1000', pointerEvents: 'none', width: '1080px', height: '300px', background: 'no-repeat url(images/logo_client.png)'}}
			></div>

			{/* Dialog background */}
			<div
				hidden={!dialog}
				style={{position: 'absolute', zIndex: '1001', width: '1080px', height: '1920px', background: 'rgba(0, 0, 0, .85)'}}
				onClick={function() {
					Com.setVariable('', 'dialog', null)
				}}
			></div>
			<img src='images/back1.png' style={{position: 'absolute', left: '0px', top: '0px', zIndex: '999', pointerEvents: 'none', width: '1080px', height: '1920px', objectFit: 'fill', opacity: '0.35', mixBlendMode: 'screen'}} />

			{/* Num pad */}
			<div style={{
				position: 'absolute',
				left: (1080/2+70)+'px',
				bottom: '0px',
				zIndex: '1005',
				width: (1080/2-70-70)+'px',
				visibility: numPadVisible?'visible':'hidden'
			}}>
				<Keyboard
					theme={'hg-theme-default myTheme'}
					onKeyPress={function(button) {
						Com.setVariable('', 'numPadValue', numPadValue+button)
					}}
					layout={{
						default: [
							'1 2 3',
							'4 5 6',
							'7 8 9',
							'0'
						]
					}}
				/>
			</div>

			{/* Keyboard */}
			<div style={{
				position: 'absolute',
				left: '70px',
				top: '30px',
				zIndex: '1000',
				width: (1080-70-70)+'px',
				visibility: keyboardVisible?'visible':'hidden'
			}}>
				<Keyboard
					theme={'hg-theme-default myTheme'}
					onKeyPress={function(button) {
						if (button === '{space}') button = ' '
						let input = searchInputRef.current
						if (!input) return
						let cursorPosition = input.selectionStart
						let newValue = null
						if (button === '{bksp}') {
							if (cursorPosition === 0) return
							let textBeforeCursorPosition = input.value.substring(0, cursorPosition-1)
							let textAfterCursorPosition = input.value.substring(cursorPosition, input.value.length)
							newValue = textBeforeCursorPosition + textAfterCursorPosition
							cursorPosition--
						}
						else {
							let textBeforeCursorPosition = input.value.substring(0, cursorPosition)
							let textAfterCursorPosition = input.value.substring(cursorPosition, input.value.length)
							newValue = textBeforeCursorPosition + button + textAfterCursorPosition
							cursorPosition++
						}
						input.value = newValue
						input.setSelectionRange(cursorPosition, cursorPosition)
						Com.setVariable('', 'searchTerm', newValue)
					}}
					layout={{
						default: [
							'1 2 3 4 5 6 7 8 9 0',
							'a z e r t y u i o p',
							'q s d f g h j k l m',
							'w x c v b n {bksp}',
							'{space}',
						]
					}}
					display={{
						'{bksp}': '⌫',
						'{space}': 'Espace'
					}}
					useMouseEvents={true}
					preventMouseDownDefault={true}
				/>
			</div>

			{/* Call dialogs */}
			<div style={{position: 'relative'}}>
				<div hidden={dialog !== 'call_bar'} style={{position: 'absolute', left: '210px', top: '240px', zIndex: '1002', textAlign: 'left'}}>
					<img
						src='images/icon_clear.png'
						style={{float: 'right'}}
						onClick={function() {
							Com.setVariable('', 'dialog', null)
						}}
					/>
					<div style={{clear: 'both'}}></div>
					<div className='borderBlue' style={{background: 'black', width: '600px', height: '300px', padding: '15px 25px 15px 25px', borderRadius: '7px'}}>
						<div style={{textAlign: 'right'}}>
							<span className="open25">{_("Appel bar")}</span>
						</div>
						<div style={{padding: '70px 0px 30px 0px'}}>
							<span className="open25">{_("Faire venir un serveur ?")}</span>
						</div>
						<div style={{margin: 'auto', width: '150px', paddingTop: '30px'}}>
							<div
								style={{float: 'left'}}
								onClick={function() {
									Com.setVariable('', 'dialog', 'call_bar_ok')
									Com.setVariable('', 'assistanceTimerConf', [Date.now(), 0, 24*60*60, 0.5])
									Com.setVariable('', 'assistanceType', 'bar')
								}}
							>
								<img src='images/icon_tick.png'/>
								<div style={{textAlign: 'center'}}>
									<span className="open25">{_("Oui !")}</span>
								</div>
							</div>
							<div
								style={{float: 'left', paddingLeft: '22px'}}
								onClick={function() {
									Com.setVariable('', 'dialog', null)
								}}
							>
								<img src='images/icon_clear.png'/>
								<div style={{textAlign: 'center'}}>
									<span className="open25">{_("Non")}</span>
								</div>
							</div>
							<div style={{clear: 'both'}}></div>
						</div>
					</div>
				</div>
			</div>
			<div style={{position: 'relative'}}>
				<div hidden={dialog !== 'call_bar_ok'} style={{position: 'absolute', left: '210px', top: '240px', zIndex: '1002', textAlign: 'left'}}>
					<img
						src='images/icon_clear.png'
						style={{float: 'right'}}
						onClick={function() {
							Com.setVariable('', 'dialog', null)
						}}
					/>
					<div style={{clear: 'both'}}></div>
					<div className='borderBlue' style={{background: 'black', width: '600px', height: '300px', padding: '15px 25px 15px 25px', borderRadius: '7px'}}>
						<div style={{textAlign: 'right'}}>
							<span className="open25">{_("Appel bar")}</span>
						</div>
						<div style={{padding: '70px 0px 0px 0px'}}>
							<span className="open25">{_("On arrive !" )}</span>
						</div>
					</div>
				</div>
			</div>
			<div style={{position: 'relative'}}>
				<div hidden={dialog !== 'call_help'} style={{position: 'absolute', left: '210px', top: '240px', zIndex: '1002', textAlign: 'left'}}>
					<img
						src='images/icon_clear.png'
						style={{float: 'right'}}
						onClick={function() {
							Com.setVariable('', 'dialog', null)
						}}
					/>
					<div style={{clear: 'both'}}></div>
					<div className='borderBlue' style={{background: 'black', width: '600px', height: '300px', padding: '15px 25px 15px 25px', borderRadius: '7px'}}>
						<div style={{textAlign: 'right'}}>
							<span className="open25">{_("Assistance")}</span>
						</div>
						<div style={{padding: '70px 0px 30px 0px'}}>
							<span className="open25">{_("Faire intervenir un membre de notre personnel ?")}</span>
						</div>
						<div style={{margin: 'auto', width: '150px', paddingTop: '30px'}}>
							<div
								style={{float: 'left'}}
								onClick={function() {
									Com.setVariable('', 'dialog', 'call_help_ok')
									Com.setVariable('', 'assistanceTimerConf', [Date.now(), 0, 24*60*60, 0.5])
									Com.setVariable('', 'assistanceType', 'help')
								}}
							>
								<img src='images/icon_tick.png'/>
								<div style={{textAlign: 'center'}}>
									<span className="open25">{_("Oui !")}</span>
								</div>
							</div>
							<div
								style={{float: 'left', paddingLeft: '22px'}}
								onClick={function() {
									Com.setVariable('', 'dialog', null)
								}}
							>
								<img src='images/icon_clear.png'/>
								<div style={{textAlign: 'center'}}>
									<span className="open25">{_("Non")}</span>
								</div>
							</div>
							<div style={{clear: 'both'}}></div>
						</div>
					</div>
				</div>
			</div>
			<div style={{position: 'relative'}}>
				<div hidden={dialog !== 'call_help_ok'} style={{position: 'absolute', left: '210px', top: '240px', zIndex: '1002', textAlign: 'left'}}>
					<img
						src='images/icon_clear.png'
						style={{float: 'right'}}
						onClick={function() {
							Com.setVariable('', 'dialog', null)
						}}
					/>
					<div style={{clear: 'both'}}></div>
					<div className='borderBlue' style={{background: 'black', width: '600px', height: '300px', padding: '15px 25px 15px 25px', borderRadius: '7px'}}>
						<div style={{textAlign: 'right'}}>
							<span className="open25">{_("Assistance")}</span>
						</div>
						<div style={{padding: '70px 0px 0px 0px'}}>
							<span className="open25">{_("On arrive !")}</span>
						</div>
					</div>
				</div>
			</div>

			{/* Title and time */}
			<div style={{padding: '70px 70px 0px 70px'}}></div>
			<div style={{background: `no-repeat url(images/karaworld.png)`,}}>
				<div style={{padding: '205px 70px 0px 70px'}}>
					<div
						style={{float: 'left', opacity: soft === 'v2'?1:0}}
						onClick={function() {
							if (soft !== 'v2') return
							// Réinit tout quand on part
							Com.setVariable('', 'demo', false)
							Com.setVariable('', 'micro1Volume', 0.25)
							Com.setVariable('', 'micro2Volume', 0.25)
							Com.setVariable('', 'guide', false)
							Com.setVariable('', 'autoTune', false)
							Com.setVariable('', 'musicTimerConf', null)
							Com.setVariable('', 'assistanceTimerConf', null)
							Com.setVariable('', 'assistanceType', null)
							Com.setVariable('', 'dialog', null)
							Com.setVariable('', 'keyboardVisible', false)
							Com.setVariable('', 'searchTerm', '')
							Com.setVariable('', 'currentCategory', null)
							Com.setVariable('', 'playlist', [])
							Com.setVariable('', 'playerIndex', 0)
							Com.setVariable('', 'photosensibleMode', false)
							Com.setVariable('', 'accessibilityMode', false)
							Com.setVariable('', 'atmosphereId', 'welcome')
							Audio.stop()
							Com.setVariable('', 'activeGame', null)
						}}
					>
						<img src='images/icon_home.png'/>
						<div style={{textAlign: 'center'}}>
							<span className="open25">{_("Retour menu")}</span>
						</div>
					</div>
					<span style={{float: 'right', marginTop: '19px', fontFamily: 'Open Sans Condensed Light', fontSize: '40px'}}>
					{
						session === 'closed' && Util.formatDurationMSOrHMS(0)
						|| session === 'waitForClick' && Util.formatDurationMSOrHMS(sessionAmount)
						|| session === 'opened' && Util.formatDurationMSOrHMS(sessionAmount-sessionTimerPosition)
						|| session === 'lastSong' && Util.formatDurationMSOrHMS(0)
					}
					</span>
				</div>
			</div>

			{session === 'waitForClick' &&
				<div style={{padding: '120px 70px 0px 390px'}}>
					<div
						style={{width: '268px', height: '86px', background: '#303030', padding: '21px 16px 21px 16px', borderRadius: '7px', textAlign: 'center'}}
						onClick={function() {
							Com.setVariable('', 'sessionTimerConf', [Date.now(), 0, sessionAmount, 1])
						}}
					>
						<span style={{fontFamily: 'Adobe Caslon Pro Bold', fontSize: '50px', lineHeight: '100px'}}>{_("Démarrer")}</span>
					</div>
				</div>
			}
			{(session === 'closed' || session == 'lastSong') &&
				<div style={{padding: '120px 70px 0px 70px'}}>
					<div style={{width: '908px', height: '86px', padding: '21px 16px 21px 16px', borderRadius: '7px', textAlign: 'center'}}>
						<span style={{fontFamily: 'Open Sans Condensed Light', fontSize: '50px', lineHeight: '100px'}}>
						{
							session === 'closed' && <span>{_("Session terminée")}</span>
							|| session == 'lastSong' && <span>{_("Dernière chanson !")}</span>
						}
						</span>
					</div>
				</div>
			}

			{session === 'opened' &&
				<div>

					{/* Search */}
					<div style={{padding: '90px 70px 0px 70px'}}>
						<img
							src='images/icon_search.png'
							onClick={function() {
								searchInputRef.current.focus()
							}}
						/>
						<input
							type='text'
							ref={searchInputRef}
							id='theOnlyInput'
							spellCheck='false'
							placeholder={_("Rechercher...")}
							autoComplete='off'
							className={(searchTerm !== ''?'borderBlue':'borderWhite')+' focusableBorder'}
							style={{width: '400px', fontFamily: 'Adobe Caslon Pro Regular', fontSize: '26px', background: 'black', color: 'white', borderRadius: '7px', padding: '10px 0px 3px 13px', marginLeft: '30px', verticalAlign: 'top'}}
							onFocus={function() {
								Com.setVariable('', 'keyboardVisible', true)
								Com.setVariable('', 'currentCategory', null)
							}}
							onBlur={function() {
								Com.setVariable('', 'keyboardVisible', false)
							}}
							value={searchTerm}
							onChange={function() {}}
						/>
						<img
							src='images/icon_clear.png'
							style={{marginLeft: '30px', visibility: (searchTerm === '' && document.activeElement !== searchInputRef.current)?'hidden':'visible'}}
							onClick={function() {
								searchInputRef.current.value = ''
								Com.setVariable('', 'searchTerm', '')
							}}
						/>
					</div>

					{/* Category */}
					<div hidden={!currentCategory} style={{position: 'relative'}}>
						<div style={{position: 'absolute', left: '70px', top: '20px', zIndex: '500', textAlign: 'left'}}>
							<img
								src='images/icon_back.png'
								style={{float: 'left', padding: '0px 0px 0px 0px'}}
								onClick={function() {
									resetTilesScroll = true
									Com.setVariable('', 'currentCategory', null)
								}}
							/>
							<div style={{float: 'left', padding: '17px 0px 0px 0px'}}>
								<span style={{fontFamily: 'Adobe Caslon Pro Bold', fontSize: '52px', color: '#1d8dd6'}}>{currentCategory ? currentCategory.split('/').map(item => _(item)).join('/') : ''}</span>
							</div>
							<div style={{clear: 'both'}}></div>
						</div>
					</div>

					{/* Tiles */}
					<div style={{position: 'relative'}}>
						{animateTile &&
							<div id='animateTile' style={{position: 'absolute', left: (70+320*animateTile.y-document.getElementById('tiles').scrollLeft)+'px', top: (100+148*animateTile.x+animateTileOffset)+'px', zIndex: '1002', textAlign: 'left'}}>
								<div style={{width: '268px', height: '86px', background: '#303030', padding: '21px 16px 21px 16px', borderRadius: '7px', textAlign: 'left'}}>
									<div>
										<span style={{fontFamily: 'Adobe Caslon Pro Bold', fontSize: '28px', lineHeight: '24px'}}>{animateTile.song.title}</span>
									</div>
									<div style={{marginTop: '5px'}}>
										<span style={{fontFamily: 'Adobe Caslon Pro Semibold', fontSize: '18px', color: '#909090'}}>{animateTile.song.artist}</span>
									</div>
								</div>
							</div>
							}
					</div>
					<div id='tiles' className='hideScrollbar' style={{overflow: 'scroll'}} onScroll={function() {
						if (currentCategory === null && searchTerm === '') {
							categoriesTilesScrollValue = document.getElementById('tiles').scrollLeft
						}
					}}>
						<div style={{padding: '100px 70px 50px 70px', width: ((300+20)*(tilesWidth-1)-20)+'px'}}>
							{Array.apply(0, Array(tilesWidth*tilesHeight)).map(function(num, i) {
								let x = Math.floor(i/tilesWidth)
								let y = i%tilesWidth
								if (y === tilesWidth-1) return (
									<div key={i} style={{clear: 'both'}}></div>
								)
								else {
									if (filteredSongs) {
										let song = filteredSongs[y*tilesHeight+x]
										// Position d'un titre dans la playlist des titres à venir
										let songIdx = song ? playlist.indexOf(song.id, playerIndex) : -1
										if (!song) return (<div key={i} style={{float: 'left', marginTop: x>0?'20px':'0px', marginLeft: y>0?'20px':'0px', width: '268px', height: '86px', padding: '21px 16px 21px 16px'}}></div>)
										else return (
											<div
												key={i}
												// Style transparent si le titre est en attente dans la playlist
												// La tuile retrouve son opacité lorsque le titre passe dans l'historique
												className={songIdx >= 0 ? 'active-tile' : ''}
												style={{float: 'left', marginTop: x>0?'20px':'0px', marginLeft: y>0?'20px':'0px', width: '268px', height: '86px', background: '#303030', padding: '21px 16px 21px 16px', borderRadius: '7px', textAlign: 'left'}}
												onClick={function() {
													if ((playlist.length === 0 || !musicTimerConfMagicData.getValue()) && !loading) {
														Com.setVariable('', 'demo', false)
														Com.setVariable('', 'playlist', playlist.concat([song.id]))
														playSong(song.id, 0)
													} else if (songIdx >= 0) {
														// Si le titre est déjà en cours de lecture on ne fait rien
														if(!currentSong || currentSong.id === song.id) return
														// Forcer la lecture d'un titre en coupe-file
														playSong(playlist[songIdx], songIdx)
													} else {
														// Si le titre n'est pas dans la playlist on l'ajoute
														Com.setVariable('', 'playlist', playlist.concat([song.id]))
													}
													setAnimateTile({song: song, x: x, y: y})
													setAnimateTileOffset(0)
												}}
											>
												<div>
													<span style={{fontFamily: 'Adobe Caslon Pro Bold', fontSize: '28px', lineHeight: '24px'}}>{song.title}</span>
												</div>
												<div style={{marginTop: '5px'}}>
													<span style={{fontFamily: 'Adobe Caslon Pro Semibold', fontSize: '18px', color: '#909090'}}>{song.artist}</span>
												</div>
											</div>
										)
									}
									else {
										let category = categories[y*tilesHeight+x]
										if (!category) return (<div key={i} style={{float: 'left', marginTop: x>0?'20px':'0px', marginLeft: y>0?'20px':'0px', width: '268px', height: '86px', padding: '21px 16px 21px 16px'}}></div>)
										else return (
											<div
												key={i}
												style={{float: 'left', marginTop: x>0?'20px':'0px', marginLeft: y>0?'20px':'0px', width: '268px', height: '86px', background: '#303030', padding: '21px 16px 21px 16px', borderRadius: '7px', textAlign: 'center'}}
												onClick={function() {
													resetTilesScroll = true
													Com.setVariable('', 'currentCategory', category.join('/'))
												}}
											>
												<div className='center' style={{paddingTop: '11px'}}>
													{category.map(function(categoryItem, j) {
														return (
															<div key={j} style={{marginTop: j>0?'10px':'0px'}}>
																<span style={{fontFamily: 'Adobe Caslon Pro Bold', fontSize: '28px', lineHeight: '24px', textAlign: 'center'}}>{_(categoryItem)}</span>
															</div>
														)
													})}
												</div>
											</div>
										)
									}
								}
							})}
						</div>
					</div>

					{/* Loader */}
					{loading &&
						<div style={{position: 'relative'}}>
							<span className='loader' style={{position: 'absolute', left: '440px', top: '240px' }}></span>
						</div>
					}

					{/* Player */}
					{currentSong &&
						<div style={{padding: '20px 70px 0px 70px', textAlign: 'left'}}>
							<div style={{float: 'left', width: '790px', textAlign: 'left', background: 'transparent'}}>
								<div style={{height: '215px'}}>
									<div>
										<span style={{fontFamily: 'Adobe Caslon Pro Bold', fontSize: '70px', lineHeight: '60px'}}>{currentSong.title}</span>
									</div>
									<div style={{marginTop: '5px'}}>
										<span style={{fontFamily: 'Adobe Caslon Pro Semibold', fontSize: '45px', color: '#808080'}}>{currentSong.artist}</span>
									</div>
								</div>
								<div style={{float: 'left'}}>
									<img
										src='images/icon_previous.png'
										style={{opacity: playerIndex === 0?0.25:1}}
										onClick={function() {
											if (playerIndex === 0) return
											let previousSongIdx = playerIndex-1
											let previousSongId = playlist[previousSongIdx]
											Com.setVariable('', 'demo', false)
											playSong(previousSongId, previousSongIdx)
										}}
									/>
								</div>
								<div style={{float: 'left', marginLeft: '20px'}}>
									<img
										src={'images/icon_'+(playing?'pause':'play')+'.png'}
										onClick={function() {
											Com.setVariable('', 'musicTimerConf', [Date.now(), musicTimerPosition, currentSong.duration, playing?0:0.02, currentSong.id])
										}}
									/>
								</div>
								<div style={{float: 'left', marginLeft: '20px'}}>
									<img
										src='images/icon_next.png'
										style={{opacity: playerIndex === playlist.length-1?0.25:1}}
										onClick={function() {
											if (playerIndex === playlist.length-1) return
											let nextSongIdx = playerIndex+1
											let nextSongId = playlist[nextSongIdx]
											Com.setVariable('', 'demo', false)
											playSong(nextSongId, nextSongIdx)
										}}
									/>
								</div>
								<div
									className={guide?'active-icon':''}
									style={{float: 'left', marginLeft: '130px', width: '75px', textAlign: 'center'}}
									onClick={function() {
										Com.setVariable('', 'guide', !guide)
									}}
								>
									<img src='images/icon_guide.png'/>
									<div style={{textAlign: 'center'}}>
										<span className="open25">{_("Guide")}<br/>{_("vocal")}</span>
									</div>
								</div>
								<div
									className={autoTune?'active-icon':''}
									style={{float: 'left', marginLeft: '20px', width: '75px', textAlign: 'center'}}
									onClick={function() {
										Com.setVariable('', 'autoTune', !autoTune)
									}}
								>
									<img src='images/icon_micro.png'/>
									<div style={{textAlign: 'center'}}>
										<span className="open25">{_("Auto-tune")}</span>
									</div>
								</div>
								<div style={{clear: 'both'}}></div>
								<HorizontalSlider
									color={'#be346d'}
									style={{marginTop: '40px', width: '790px'}}
									value={musicTimerPosition}
									setValue={function(newValue) {
										Com.setVariable('', 'musicTimerConf', [Date.now(), newValue, currentSong.duration, 0.02, currentSong.id])
									}}
									scale={currentSong.duration}
								/>
								<div style={{float: 'left', marginTop: '7px'}}>
									<span className="open25">{Util.formatDurationMS(Math.floor(musicTimerPosition))}</span>
								</div>
								<div style={{float: 'right', marginTop: '7px'}}>
									<span className="open25">-{Util.formatDurationMS(Math.round(currentSong.duration) - Math.floor(musicTimerPosition))}</span>
								</div>
								<div style={{clear: 'both'}}></div>
							</div>
							<div style={{float: 'left', width: '75px', height: '350px', background: 'transparent'}}>
								<div style={{textAlign: 'center'}}>
									<span className="open25">{_("Micros")}</span>
								</div>
								<VolumeSlider
									levels={12}
									color={'white'}
									style={{paddingTop: '15px', width: '37px', margin: 'auto'}}
									value={micro2Volume}
									setValue={function(newValue) {
										Com.setVariable('', 'micro1Volume', newValue)
										Com.setVariable('', 'micro2Volume', newValue)
									}}
									scale={1}
								/>
							</div>
							<div style={{float: 'left', width: '75px', height: '350px', background: 'transparent'}}>
								<div style={{textAlign: 'center'}}>
									<span className="open25">{_("Musique")}</span>
								</div>
								<VolumeSlider
									levels={12}
									style={{paddingTop: '15px', width: '37px', margin: 'auto'}}
									value={softVolume}
									setValue={function(newValue) {
										Com.setVariable('', 'settings.volume', newValue)
									}}
									scale={1}
								/>
							</div>
							<div style={{clear: 'both'}}></div>
						</div>
					}

					{/* Playlist */}
					{currentSong &&
						<div id='playlist' className='hideScrollbar' style={{overflow: 'scroll'}}>
							<div style={{padding: '20px 70px 50px 70px', width: ((300+20)*playlist.length-20)+'px'}}>
								{playlist.map(function(songId, i) {
									let song = Songs[songId]
									let isTheCurrentSong = playerIndex === i
									let className = ''
									if (isTheCurrentSong) className = 'borderRed'
									else if (i<playerIndex) className = 'active-tile'
									return (
										<div
											key={i}
											className={className}
											style={{float: 'left', marginLeft: i==0?'0px':'20px', width: '268px', height: '86px', background: isTheCurrentSong?'black':'#303030', padding: isTheCurrentSong?'16px 11px 16px 11px':'21px 16px 21px 16px', borderRadius: '7px', textAlign: 'left'}}
											onClick={function() {
												if (isTheCurrentSong) return
												Com.setVariable('', 'demo', false)
												playSong(songId, i)
											}}
										>
											<div>
												<span style={{fontFamily: 'Adobe Caslon Pro Bold', fontSize: '28px', lineHeight: '24px'}}>{song.title}</span>
											</div>
											<div style={{marginTop: '5px'}}>
												<span style={{fontFamily: 'Adobe Caslon Pro Semibold', fontSize: '18px', color: '#909090'}}>{song.artist}</span>
											</div>
										</div>
									)
								})}
							</div>
						</div>
					}

					{/* Atmospheres */}
					{currentSong && !photosensibleMode &&
						<div style={{position: 'relative'}}>
							<div style={{position: 'absolute', zIndex: '1000', left: '0px', top: '0px', width: '1080px'}}>
								<div id='atmospheres' className='hideScrollbar' style={{overflow: 'scroll'}}>
									<div style={{padding: '20px 70px 50px 70px', width: ((300+20)*currentSong.atmosphereIds.length-20)+'px'}}>
										{currentSong.atmosphereIds.map(function(anAtmosphereId, i) {
											let atmosphere = Atmospheres[anAtmosphereId]
											let isTheCurrentAtmosphere = anAtmosphereId === atmosphereId
											return (
												<div
													key={i}
													className={isTheCurrentAtmosphere?'borderBlue':''}
													style={{float: 'left', marginLeft: i>0?'20px':'0px', width: '268px', height: '86px', background: 'url(decors/'+atmosphere.icon+')', backgroundPosition: isTheCurrentAtmosphere?'-5px -5px':'', padding: isTheCurrentAtmosphere?'16px 11px 16px 11px':'21px 16px 21px 16px', borderRadius: '7px', textAlign: 'left'}}
													onClick={function() {
														if (isTheCurrentAtmosphere) return
														Com.setVariable('', 'atmosphereId', anAtmosphereId)
													}}
												>
												</div>
											)
										})}
									</div>
								</div>
							</div>
						</div>
					}

				</div>
			}

			{/* Buttons */}
			<div style={{position: 'absolute', bottom: '0px', padding: '0px 0px 35px 50px'}}>
				<div
					className={accessibilityMode?'active-icon':''}
					style={{float: 'left'}}
					onClick={function() {
						Com.setVariable('', 'accessibilityMode', !accessibilityMode)
					}}
				>
					<img src='images/icon_accessibility.png'/>
					<div style={{textAlign: 'center'}}>
						<span className="open25">{_("Mode")}<br/>{_("accessibilité" )}</span>
					</div>
				</div>
				<div
					className={photosensibleMode?'active-icon':''}
					style={{float: 'left', marginLeft: '30px'}}
					onClick={function() {
						Com.setVariable('', 'photosensibleMode', !photosensibleMode)
					}}
				>
					<img src='images/icon_photosensible.png'/>
					<div style={{textAlign: 'center'}}>
						<span className="open25">{_("Mode")}<br/>{_("photosensible") }</span>
					</div>
				</div>
				<div
					style={assistanceCalls ? {float: 'left', marginLeft: '30px'} : {float: 'left', marginLeft: '30px', opacity: 0, pointerEvents: 'none'}}
					onClick={function() {
						Com.setVariable('', 'dialog', 'call_help')
					}}
				>
					<img src='images/icon_help.png'/>
					<div style={{textAlign: 'center'}}>
						<span className="open25">{_("Assistance")}</span>
					</div>
				</div>
				<div
					style={barCalls ? {float: 'left', marginLeft: '30px'} : {float: 'left', marginLeft: '30px', opacity: 0, pointerEvents: 'none'}}
					onClick={function() {
						Com.setVariable('', 'dialog', 'call_bar')
					}}
				>
					<img src='images/icon_bar.png'/>
					<div style={{textAlign: 'center'}}>
						<span className="open25">{_("Appel bar")}</span>
					</div>
				</div>
				<div style={{clear: 'both'}}></div>
			</div>

		</div>

	)
}

export default Terminal
